import { inject, Injectable, makeEnvironmentProviders, NgZone, signal } from '@angular/core';
import { interval } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VersionCheckerService {
  private ngZone = inject(NgZone);
  currentAppVersion = signal<string | null>(null);
  currentAppVersionUpdated = signal<string>(null);

  initVersionCheck(intervalMs: number) {
    this.ngZone.runOutsideAngular(() => {
      interval(intervalMs).subscribe(() => {
        this.loadVersionFile();
      });
    });
  }

  private loadVersionFile() {
    const request = new XMLHttpRequest();

    request.addEventListener('load', (_) => {
      if (request.status === 200) {
        try {
          const data = JSON.parse(request.responseText);
          const current = this.currentAppVersion();

          if (current === null) {
            this.currentAppVersion.set(data.version);
          } else if (current !== data.version) {
            this.currentAppVersionUpdated.set(data.version);
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        console.error('CANNOT LOAD VERSION FILE!!!');
      }
    });
    const appPath = location.pathname.split('/').slice(0, 3).join('/');
    const prefix = location.pathname.startsWith('/apps/') ? appPath : '';
    request.open('GET', `${prefix}/version.json`);
    request.send();
  }
}
